$(document).ready(function() {

  var currentTime = new Date(); 
  var index = $(location).attr('href')
  //console.log(index);

  // get current time  0= Sunday, 1= Monday, 2= Tue, 3= Wed, 4= thu, 5= friday 6= sat
  // if day is mon-Fri and time is between 8am and 4pm
  //var d = new Date();

  var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
  var dayOfWeek = d.getDay();
  var hour = d.getHours();
  var mins = d.getMinutes();
  var status = 'live';

  if (dayOfWeek !== 0 && dayOfWeek !== 6 && hour >= 8 && hour < 16){   
    status = 'live';    
  }else{
    status = 'afterHours';
  }

  if (status=='live') {
    $(".custom-product .help").css("display","inline-block");
  }
  else{
    $(".custom-product .after-hours.typeform").css("display","inline-block");    
  } 


  $('#section-footer .Footer__Block:nth-child(1) .Linklist .Linklist__Item:last-child a').attr('target', '_blank'); 

  $("#s-f0e94d7a-65cd-4faa-ad0e-e6bac7acf44c .shg-rich-text span").attr("tabindex","0");

  if (window.location.hash) {
    var PopupEmbedLink = "https://www.youtube.com/embed/9_G3_xLE0wU?autoplay=1";

    $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content videoBox"><span class="YouTubePopUp-Close"></span><iframe src="'+PopupEmbedLink+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></div>');
    if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
      setTimeout(function() {
        $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
      }, 600);
      $(".supports-hover").addClass( "no-scroll" );	
    }

    $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
      $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
      $("#s-f0e94d7a-65cd-4faa-ad0e-e6bac7acf44c .shg-rich-text span").focus();
      $(".supports-hover").removeClass( "no-scroll" );
    });

    $(document).keyup(function(e) {

      if ( e.keyCode == 27 ){
        $('.YouTubePopUp-Wrap, .YouTubePopUp-Close').click();
        $("#s-f0e94d7a-65cd-4faa-ad0e-e6bac7acf44c .shg-rich-text span").focus();
        $(".supports-hover").removeClass( "no-scroll" );
      }

    });   

  }

  // Scroll sticky  
  $(window).scroll(function(){
    var sticky = $('.sticky'),
        scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');

    var sticky = $('.plan-title'),
        scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  $(window).scroll(function(){
    if ($(window).scrollTop() >= 800) {
      $('.shg-product .shogun-tabs').addClass('fixed-header');
      $('#s-973a1c0a-04ee-4fa2-855b-e33025f28cec .shogun-tabs').addClass('fixed-header'); 
      $('.shogun-tabs.shogun-modern').addClass('fixed-header'); 

    }
    else {
      $('.shg-product .shogun-tabs').removeClass('fixed-header'); 
      $('#s-973a1c0a-04ee-4fa2-855b-e33025f28cec .shogun-tabs').removeClass('fixed-header'); 
      $('.shogun-tabs.shogun-modern').removeClass('fixed-header'); 
    }
  });

  $('.shogun-tab').on('click', function(e) {
    e.preventDefault();            
    if(window.outerWidth <=767) {
      //alert('moe');
      $('html, body').animate({
        scrollTop: $(".shogun-tab-content.shogun-tab-active").offset().top
      }, 420);
    } else {
      $('html, body').animate({
        scrollTop: $(".shogun-tab-content.shogun-tab-active").offset().top
      }, 2000);
    }
  });

  // ===== Scroll to Top ==== 
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
      $('#return-to-top').fadeIn(200);    // Fade in the arrow
    } else {
      $('#return-to-top').fadeOut(200);   // Else fade out the arrow
    }
  });
  $('#return-to-top').click(function() {      // When arrow is clicked
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
    }, 500);
  });

  //  Youtube code   
  $.fn.YouTubePopUp = function(options) {

    var YouTubePopUpOptions = $.extend({
      autoplay: 1
    }, options );

    $(this).on('click', function (e) {

      var youtubeLink = $(this).attr("href");

      if( youtubeLink.match(/(youtube.com)/) ){
        var split_c = "v=";
        var split_n = 1;
      }

      if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(vimeo.com\/)+[0-9]/) ){
        var split_c = "/";
        var split_n = 3;
      }

      if( youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
        var split_c = "/";
        var split_n = 5;
      }

      var getYouTubeVideoID = youtubeLink.split(split_c)[split_n];

      var cleanVideoID = getYouTubeVideoID.replace(/(&)+(.*)/, "");

      if( youtubeLink.match(/(youtu.be)/) || youtubeLink.match(/(youtube.com)/) ){
        var videoEmbedLink = "https://www.youtube.com/embed/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
      }

      if( youtubeLink.match(/(vimeo.com\/)+[0-9]/) || youtubeLink.match(/(vimeo.com\/)+[a-zA-Z]/) ){
        var videoEmbedLink = "https://player.vimeo.com/video/"+cleanVideoID+"?autoplay="+YouTubePopUpOptions.autoplay+"";
      }

      $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+videoEmbedLink+'" allowfullscreen></iframe></div></div>');

      if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
        setTimeout(function() {
          $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
        }, 600);
      }

      $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
        $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
      });

      e.preventDefault();

    });

    $(document).keyup(function(e) {

      if ( e.keyCode == 27 ){
        $('.YouTubePopUp-Wrap, .YouTubePopUp-Close').click();
      }

    });

  }

  $("a.video").YouTubePopUp();  
  $(".product-mobile a.video-svg").YouTubePopUp();
   $(".product-big-image a.video-svg").YouTubePopUp();
  $(".global-mila a.video-svg").YouTubePopUp();
  // Day and Night Effect on the image
  var selector = $('#top'); 
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 1200) {
      // The element is visible, do something           
      selector.fadeTo( 2500 , 0, function() {
        $('.trans-img-1').css({'z-index': 'unset'})
        // Animation complete.
      });
    }   
  });


  // Div ID for Tabs
  $(".shg-product .shogun-tabs li").each(function(i, v) {
    $(this).attr('id', "tab-" + i)
    $('.shogun-tab-content').eq(i).attr('id', "tab-" + i)
  })

  var url = window.location.href;
  var c = url.substring(url.lastIndexOf('#') + 1);
  //console.log(c);

  if (c == 'tab-2') {
    var id = url.substring(url.lastIndexOf('#'));
    //alert(id); //outputs #ShowThisDiv 
    $(".shg-product #tab-2").addClass( "shogun-tab-active" );
    $('.shg-product #tab-0').removeClass('shogun-tab-active');
    //$(".supports-hover").addClass("no-scroll");

  }

  // Add class if Country pop up  
  if ( $( "#cozyCRModal" ).length ) {
    //alert('this record already exists');
    $('.PageContainer').addClass('country-header');
  } else {
    // do stuff
    $('.PageContainer').removeClass('country-header');
  }

  // ADD class for Oma refresh  
  var url = window.location.href;
  var refresh = url.substring(url.lastIndexOf('/') + 1);
  //console.log(ref);
  if(refresh=="oma-sense-refresh"){
    $(".shogun-root").addClass('shg-product');      
    if(window.outerWidth <=767) {
      $('.ProductMeta__PriceList.Heading').before( '<div style="text-align:center !important;position: relative;left: 15px;margin-top: 5px;" data-bv-show="rating_summary" data-bv-product-id="4429485113399"></div>' );
    }
  }
  
  if(refresh=="mila-power-supply-with-monitor-cable" ||  refresh == "mila-additional-1-5m-cable-and-adapter-for-monitor"){
    $('.Product').before('<div class="comp"><strong> COMPATIBILITY: </strong>The Mila monitor power cable is NOT compatible with previous Levana baby monitors or third-party brands. This power supply should only be used with a Mila monitor.  </div>');
  }
  
  if(refresh=="mila-camera-power-adapter" || refresh == "mila-additional-camera-power-cable"){
    $('.Product').before('<div class="comp"><strong> COMPATIBILITY: </strong>The Mila camera power cable is NOT compatible with previous Levana baby monitor camera(s) or third-party brands. This power supply should only be used with a Mila camera(s).</div>');
  }
  
  if(refresh=="mila-camera-mounting-kit" ){
    $('.Product').before('<div class="comp"><strong> COMPATIBILITY: </strong>We recommend using this mounting hardware with the Mila camera ONLY and not with other Levana models or third-party brands.</div>');
  }

  //Tool tip 
  var targets = $( '[rel~=tooltip]' ),
      target	= false,
      tooltip = false,
      title	= false;

  targets.bind( 'mouseenter', function()
               {
    target	= $( this );
    tip		= target.attr( 'title' );
    tooltip	= $( '<div id="tooltip"></div>' );

    if( !tip || tip == '' )
      return false;

    target.removeAttr( 'title' );
    tooltip.css( 'opacity', 0 )
    .html( tip )
    .appendTo( 'body' );

    var init_tooltip = function()
    {
      if( $( window ).width() < tooltip.outerWidth() * 1.5 )
        tooltip.css( 'max-width', $( window ).width() / 2 );
      else
        tooltip.css( 'max-width', 340 );

      var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ),
          pos_top	 = target.offset().top - tooltip.outerHeight() - 20;

      if( pos_left < 0 )
      {
        pos_left = target.offset().left + target.outerWidth() / 2 - 20;
        tooltip.addClass( 'left' );
      }
      else
        tooltip.removeClass( 'left' );

      if( pos_left + tooltip.outerWidth() > $( window ).width() )
      {
        pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
        tooltip.addClass( 'right' );
      }
      else
        tooltip.removeClass( 'right' );

      if( pos_top < 0 )
      {
        var pos_top	 = target.offset().top + target.outerHeight();
        tooltip.addClass( 'top' );
      }
      else
        tooltip.removeClass( 'top' );

      tooltip.css( { left: pos_left, top: pos_top } )
      .animate( { top: '+=10', opacity: 1 }, 50 );
    };

    init_tooltip();
    $( window ).resize( init_tooltip );

    var remove_tooltip = function()
    {
      tooltip.animate( { top: '-=10', opacity: 0 }, 50, function()
                      {
        $( this ).remove();
      });

      target.attr( 'title', tip );
    };

    target.bind( 'mouseleave', remove_tooltip );
    tooltip.bind( 'click', remove_tooltip );
  });

  //Warranty add to cart Function   
  $('.warranty-shop.one').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("warranty_id");
    var warranty = $("#plan").text();
    //alert(warranty);      
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : warranty}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      }          
    });     
  }); 

  //Accident Protection Plan  
  $('.omasense').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Oma").html($(this).attr("data-value"));
    $(".omasense-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".omasense-popup").hide();
        $(".omasense").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".omasense-popup").hide();
      $(".omasense").focus();
      //window.location.reload();	
    });      

  });

  //Oma Sense Accident Product add to cart Function  
  $('.cart-button.one').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var OmaTitle = $("#Oma").text();
    //alert(warranty); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : OmaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 
  
  $('.omasenseOB').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#OmaOB").html($(this).attr("data-value"));
    $(".omasenseOB-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".omasenseOB-popup").hide();
        $(".omasenseOB").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".omasenseOB-popup").hide();
      $(".omasenseOB").focus();
      //window.location.reload();	
    });      

  });

  $('.cart-button.two').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var OmaOBTitle = $("#OmaOB").text();
    //alert(warranty); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : OmaOBTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.mila').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Mila").html($(this).attr("data-value"));
    $(".mila-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".mila-popup").hide();
        $(".mila").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".mila-popup").hide();
      $(".mila").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila Accident Product add to cart Function  
  $('.cart-button.two').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Mila").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.mila2cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Mila2cam").html($(this).attr("data-value"));
    $(".mila2cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".mila2cam-popup").hide();
        $(".mila2cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".mila2cam-popup").hide();
      $(".mila2cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 2CAM  Accident Product add to cart Function  
  $('.cart-button.mila2cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Mila2cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.mila3cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Mila3cam").html($(this).attr("data-value"));
    $(".mila3cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".mila3cam-popup").hide();
        $(".mila3cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".mila3cam-popup").hide();
      $(".mila3cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 3CAM Accident Product add to cart Function  
  $('.cart-button.mila3cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Mila3cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.mila4cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Mila4cam").html($(this).attr("data-value"));
    $(".mila4cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".mila4cam-popup").hide();
        $(".mila4cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".mila4cam-popup").hide();
      $(".mila4cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 4CAM Accident Product add to cart Function  
  $('.cart-button.mila4cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Mila4cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.milaopen1cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Milaopen1cam").html($(this).attr("data-value"));
    $(".milaopen1cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".milaopen1cam-popup").hide();
        $(".milaopen1cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".milaopen1cam-popup").hide();
      $(".milaopen1cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 1CAM OpenBox Accident Product add to cart Function  
  $('.cart-button.milaopen1cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Milaopen1cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.milaopen2cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Milaopen2cam").html($(this).attr("data-value"));
    $(".milaopen2cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".milaopen2cam-popup").hide();
        $(".milaopen2cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".milaopen2cam-popup").hide();
      $(".milaopen2cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 2CAM OpenBox Accident Product add to cart Function  
  $('.cart-button.milaopen2cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Milaopen2cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.milaopen3cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Milaopen3cam").html($(this).attr("data-value"));
    $(".milaopen3cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".milaopen3cam-popup").hide();
        $(".milaopen3cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".milaopen3cam-popup").hide();
      $(".milaopen3cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 3CAM OpenBox Accident Product add to cart Function  
  $('.cart-button.milaopen3cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Milaopen3cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  $('.milaopen4cam').on('click', function() {
    // CART ALert POP UP
    //alert('IN');
    //alert($(this).attr("data-value"));
    $("#Milaopen4cam").html($(this).attr("data-value"));
    $(".milaopen4cam-popup").show();    
    $('.main-header-wrapper').addClass('zindex1');
    $(document).on('keyup',function(e) {
      if (e.keyCode == 27) {
        $('.product-overlay').remove();
        $("body").removeClass( "no-scroll" );
        $(".milaopen4cam-popup").hide();
        $(".milaopen4cam").focus();
        //window.location.reload();	
      }
    });

    // CLOSE AND REMOVE ON CLICK
    $('body').on('click','.close', function() {
      $("body").removeClass( "no-scroll" );
      $(".milaopen4cam-popup").hide();
      $(".milaopen4cam").focus();
      //window.location.reload();	
    });     	  
  });

  //Mila 4CAM OpenBox Accident Product add to cart Function  
  $('.cart-button.milaopen4cam').on('click', function(e) {   
    //alert('ONE');
    var obj=$(this);
    var ID = $(this).attr("product_id");
    var MilaTitle = $("#Milaopen4cam").text();
    //alert(MilaTitle); 
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: ID,
        properties: { 'Product' : MilaTitle}
      },
      dataType: 'json', 
      success: function (cart) {  
        window.location.reload(); 	
      } 

    });     
  }); 

  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });

  //Tabs for Custome Product pages
  $('.custom-product ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.custom-product ul.tabs li').removeClass('current');
    $('.custom-product .tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

  //fixed header for Custom Product page
  $(window).scroll(function(){
    if ($(window).scrollTop() >= 800) {
      $('.custom-product ul.tabs').addClass('fixed-header');       
    }
    else {
      $('.custom-product ul.tabs').removeClass('fixed-header');        
    }
  }); 

  // onclick scroll to page up for products
  $('.tabs .tab-link').on('click', function(e) {
    //alert('IN');
    e.preventDefault();            
    if(window.outerWidth <=767) {
      //alert('mobile');
      $('html, body').animate({
        scrollTop: $(".tab-content.current").offset().top
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $(".tab-content.current").offset().top
      }, 700);
    }
  });  

  //Products Image slider
  $('.custom-product .product-mobile').hide(); 
  $('.product-slider .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.product-slider .slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
  });

  //Product Mobile SLider  
  var windowWidth = $(window).width();
  if(windowWidth <= 767) {
    $('.custom-product .desktop-show').hide();
    $('.custom-product .product-mobile').show();
    $('.custom-product .product-mobile .slider').slick({
      slide: 'div.product-mobile-image',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"    

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        }
      ]
    });
    $('.how-works .image-row').slick({
      slide: 'div.column',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"    

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true
          }
        }
      ]
    });

  } 	

  //$('iframe').attr('id','video');
  $('#productVideo').on('click', function(ev) {
    //var PopupEmbedLink = $(".youtube_video")[0].src += "&autoplay=1";
    var PopupEmbedLink = $(".youtube_video")[0].src;

    $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+PopupEmbedLink+'" allowfullscreen></iframe></div></div>');

    if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
      setTimeout(function() {
        $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
      }, 600);
    }

    $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
      $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
    });

    ev.preventDefault();
  }); 

    //$('iframe').attr('id','video');
  $('.video-watch').on('click', function(ev) {
    //var PopupEmbedLink = $(".youtube_video")[0].src += "&autoplay=1";
    var PopupEmbedLink = $(".video-watch").attr("href");

    $("body").append('<div class="YouTubePopUp-Wrap YouTubePopUp-animation"><div class="YouTubePopUp-Content"><span class="YouTubePopUp-Close"></span><iframe src="'+PopupEmbedLink+'" allowfullscreen></iframe></div></div>');

    if( $('.YouTubePopUp-Wrap').hasClass('YouTubePopUp-animation') ){
      setTimeout(function() {
        $('.YouTubePopUp-Wrap').removeClass("YouTubePopUp-animation");
      }, 600);
    }

    $(".YouTubePopUp-Wrap, .YouTubePopUp-Close").click(function(){
      $(".YouTubePopUp-Wrap").addClass("YouTubePopUp-Hide").delay(515).queue(function() { $(this).remove(); });
    });

    ev.preventDefault();
  }); 

  //Onclick add warranty Selected 
  $('.pd_warranty.warr a').click(function(e){
    $('.pd_warranty.warr a').removeClass('selected');
    $(this).addClass('selected');
  });

  //Onclick add accessories Selected 
  $('.pd_warranty.acc a').click(function(e){
    $('.pd_warranty.acc a').removeClass('selected');
    $(this).addClass('selected');
  });

  //Video slider tech specs  
  $('.tech-video-slider').slick({
    slide: 'div.video-slider',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    infinite: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "slick"    

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          autoplay: true
        }
      },{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });

  //Review slider tech specs  
  $('.review-slider').slick({
    slide: 'div.r-slider',
    centerMode: true,
    centerPadding: '0px',
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    dots: true,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 9999,
        settings: "slick"    

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          autoplay: true,
          centerMode: true
        }
      },{
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });

  //Slick For Realted Products --- CART UPSELLS Accessories
  var numItems = $(".accessories .accessories-col").length;
  //console.log(numItems);
  $('.accessories').slick({
    slide: 'div.accessories-col',
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,		
    responsive: [
      {
        breakpoint: 9999,
        settings: "slick"    

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true
        }
      },{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: true
        }
      }
    ]
  });

  $(".product-big-image img.product-image").click(function () {
    var $src = $(this).attr("src");
    $(".image-view").show();
    $(".Box img").attr("src", $src);
    $('.main-header-wrapper').addClass('zindex1');
  });

  $("span, .overlay").click(function () {
    $(".image-view").hide();
    $('.main-header-wrapper').removeClass('zindex1');
  }); 

  //Product Bundle 
  $('#bundle-add').on('click', function() {
    //alert("Contact Support Team for Bundle Pricing");
    var MilaProductId = $("#MilaId").val();
    //alert(MilaProductId);

    var OmaProductId = $("#OmaId").val();
    //alert(OmaProductId);

    var wtyProductId = $('.pd_warranty.warr a.selected').attr('warranty_id');
    //alert(wtyProductId);

    var accProductId = $('.pd_warranty.acc a.selected').attr('acc_id');
    //alert(accProductId); 

    var bundleValue = $("#OmaId").attr("data-id");
    //alert(bundleValue);

    //Bundle Mila 1 Cam insert
    if((MilaProductId!='') && (bundleValue=='1')){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: OmaProductId
        },
        dataType: 'json', 
        success: function (cart) {      
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: MilaProductId,
              note: "EXCLUSIVE BUNDLE"
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/checkout?&discount=MILA1OMA BUNDLE";               
            }
          });
        }                     
      });  
    }

    //Bundle Mila 2 Cam insert
    if((MilaProductId!='') && (bundleValue=='2')){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: OmaProductId
        },
        dataType: 'json', 
        success: function (cart) {      
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: MilaProductId,
              note: "EXCLUSIVE BUNDLE"
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/checkout?&discount=MILA2OMA BUNDLE";
            }
          });
        }                     
      });  
    }

  });

  //Onclick get Product and Warranty selected ID 
  $('#product-add').on('click', function() {
    //alert("Product testing...");
    var wtyProductId = $('.pd_warranty.warr a.selected').attr('warranty_id');
    //alert(wtyProductId);

    var ProductTitle = $("#ProductTitle").text();
    //alert(ProductTitle);                

    var accProductId = $('.pd_warranty.acc a.selected').attr('access_id');
    //alert(accProductId);  

    //Get Product ID
    var ProductId = $("#ProductId").val();
    //alert(ProductId);

    // 1 have values
    if((ProductId!='') && (wtyProductId=='NULL' || wtyProductId == undefined) && (accProductId == null || accProductId == undefined )){ 
      //alert('Product');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ProductId
        },
        dataType: 'json', 
        success: function (cart) {   
          window.location.href ="/cart";
        }           

      });                    
    }

    //IF warranty ID has value insert the Product
    if((ProductId!='') && (wtyProductId!='NULL') && (accProductId == null)) {
      //alert('Warranty');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId,
          properties: { 'Product' : ProductTitle}
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }

    //IF Accessories has value insert the Product
    if((ProductId!='') && (wtyProductId=='NULL') && (accProductId != null)) {
      //alert('Accessories');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: accProductId
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: ProductId
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href ="/cart";
            }           
          }); 
        }           
      }); 
    }

    //When all 3 have values
    if((ProductId!='') && (wtyProductId!='NULL') && (accProductId != null)) {
      //alert('3');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wtyProductId,
          properties: { 'Product' : ProductTitle}
        },
        dataType: 'json', 
        success: function (cart) {  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: accProductId
            },
            dataType: 'json', 
            success: function (cart) {
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                  quantity: 1,
                  id: ProductId
                },
                dataType: 'json', 
                success: function (cart) {   
                  window.location.href ="/cart";
                }           
              }); 
            }           
          }); 
        }           
      }); 
    }

  });

  // Partner logo SLick   
  if( $('#partner-section .list-item').length >= 3 ) {
    $('#partner-section .module-body .list').slick({
      slide: 'div.list-item',
      speed: 700,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 7000,
      slidesToScroll: 1,		
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"     

        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 1075,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true
          }
        }
      ]
    });

  }
  
  //New Product Bundle 
  $('#Product-bundle').on('click', function() {

    //Get Product ID
    var bundleProductId = $("#BundleProductId").val();
    //alert(bundleProductId);

    var PBundle = $("#bundle").text();

    //Add FreeGift to bundles  when we run the promotions
    var FreeGift = "31765963472999";

    function FreeGift() {
      /*$.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: FreeGift           
            },
            dataType: 'json'
          });*/
    }

    //Add Bundle Code
   if(bundleProductId!=''){
      //alert(Cablebundle);
       $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: bundleProductId,
              note: "EXCLUSIVE BUNDLE",
              properties: { 'Product' : PBundle}
            },
            dataType: 'json', 
            success: function (cart) {
              window.location.href = '/cart';
              //FreeGift();
              //console.log(cart);
            }           
          }); 
   }         

  });   
  
  //Expert Review   
  $('.tech-reviews').slick({
      slide: 'div.list-item',
      slidesToShow: 3,
      slidesToScroll: 1,
    arrows: true,
    centerMode:true,
      responsive: [
         {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        },{
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: true
        }
      }
      ]
    });
 

});  

//Page onload function
$(window).on('load', function () { 
  // get current time  0= Sunday, 1= Monday, 2= Tue, 3= Wed, 4= thu, 5= friday 6= sat
  // if day is mon-Fri and time is between 8am and 4pm
  //var d = new Date();

  var d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
  var dayOfWeek = d.getDay();
  var hour = d.getHours();
  var mins = d.getMinutes();
  var status = 'live';

  if (dayOfWeek !== 0 && dayOfWeek !== 6 && hour >= 8 && hour < 16){   
    status = 'live';    
  }else{
    status = 'afterHours';
  }

  if (status=='live') {
    $('#launcher').show();
    $("#launcher").css("display","block");
  }else{      
    $('.after-hours').show();
    $("#launcher").css("display","none");
  } 

});